var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.283,
    height: 45.285,
    viewBox: "0 0 74.283 45.285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M-6242.359,9819.8a8.477,8.477,0,0,1-6.346-2.481l-28.284-28.284a8.5,8.5,0,0,1,0-12.022,8.5,8.5,0,0,1,12.02,0l22.632,22.632,22.632-22.632a8.5,8.5,0,0,1,12.02,0,8.5,8.5,0,0,1,0,12.022l-28.285,28.284a8.467,8.467,0,0,1-6.009,2.49Q-6242.169,9819.806-6242.359,9819.8Z",
    transform: "translate(6279.479 -9774.521)",
    fill: "#fec260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.7b964c782fe55dbe6fd4def4e429cd9e.svg";
export { ForwardRef as ReactComponent };